import React, { ChangeEvent, TextareaHTMLAttributes } from 'react';
import styles from './TextArea.module.css';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  classes: string;
  hasError: boolean;
  handleOnChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  handleOnChange,
  classes,
  hasError,
  ...rest
}) => {
  return (
    <textarea
      value={value}
      onChange={handleOnChange}
      className={`${styles.textarea} ${classes} ${
        hasError ? styles.textarea__error : ''
      }`}
      {...rest}
    />
  );
};

TextArea.displayName = 'TextArea';
export default TextArea;
